<div *ngIf="checkViewMode('edit')" class="form-group">
  <div class="switch-container">
    <label class="switch">
      <input type="checkbox" [checked]="isChecked" (change)="onValueChange($event)" />
      <span class="slider round"></span>
    </label>
    <label>{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}
      <span *ngIf="getOptionByKey(attribute,'tooltip')"
            class="popover-info"
            [popover]="getOptionByKey(attribute,'tooltip')"
            placement="right"
            container="body"
            triggers="mouseenter:mouseleave">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
  </div>

  <span *ngIf="!isChecked"> {{textNotChecked}}</span>
  <span *ngIf="isChecked"> {{textChecked}}</span>
  <div class="row s-container" [ngClass]="{oculto: !isChecked}">
    <app-dynamic *ngFor="let item of attribute.attributes"
      [class]="getSizeClass(item)"
      [attribute]="item"
      [envOptions]="getEnvOptions()"
      [parent]="attribute"
      (onEmit)="emitEvents($event)">
    </app-dynamic>
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <p>
    <span class="title">{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}: </span>
    <span *ngIf="!isChecked"> {{textNotChecked}}</span>
    <span *ngIf="isChecked"> {{textChecked}}</span>
  </p>
  <div *ngIf="isChecked" class="row">
    <app-dynamic *ngFor="let item of attribute.attributes"
      [class]="getSizeClass(item)"
      [attribute]="item"
      [envOptions]="getEnvOptions()"
      [parent]="attribute"
      (onEmit)="emitEvents($event)">
    </app-dynamic>
  </div>
</div>
